export interface IRecipientsState {
	overviewRightPanelCollapsed: boolean,
	detailRightPanelCollapsed: boolean,
	recipientActionRefs: Array<string>,
	recipientStatus: Array<string>
}

const state: IRecipientsState = {
	overviewRightPanelCollapsed: true,
	detailRightPanelCollapsed: true,
	recipientActionRefs: [],
	recipientStatus: ['OPEN', 'DRAFT']
};

const mutations = {
	SET_OVERVIEW_RIGHT_PANEL_COLLAPSED: (state, data) => {
		state.overviewRightPanelCollapsed = data;
	},
	SET_DETAIL_RIGHT_PANEL_COLLAPSED: (state, data) => {
		state.detailRightPanelCollapsed = data;
	},
	SET_RECIPIENT_ACTION_REFS: (state, refs: Array<string>) => {
		state.recipientActionRefs = refs;
	},
	SET_RECIPIENT_STATUS: (state, data: Array<string>) => {
		state.recipientStatus = data;
	}
};

const getters = {
	// Get recipient actions from actions store, ordered by recipientActionRefs
	// Filters by recipientStatus so UPSERT_ACTION with a new status
	// reactively hides/shows rows without a server refetch
	recipientActions: (state: IRecipientsState, _getters, rootState) => {
		const statuses = state.recipientStatus;
		return state.recipientActionRefs
			.map(ref => rootState.actions.actionsByReference[ref])
			.filter(Boolean)
			.filter(action => !statuses?.length || statuses.includes(action.status));
	}
};

export default {
	namespaced: true,
	state,
	getters,
	mutations
};
